import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "id", headerName: "ID", width: 70 },

  { field: "name", headerName: "Product Name", width: 180, editable: true },

  { field: "category", headerName: "Category", width: 150, editable: true },

  { field: "qty", headerName: "Quantity", type: "number", width: 120, editable: true },

  { field: "price", headerName: "Price", type: "number", width: 120, editable: true },

  { field: "unit", headerName: "Unit", width: 120, editable: true },

  { field: "supplier", headerName: "Supplier", width: 180, editable: true },

  { field: "location", headerName: "Location", width: 150, editable: true },

  { field: "sku", headerName: "SKU", width: 150, editable: true },

  { field: "status", headerName: "Status", width: 140, editable: true },
];

const rows = [
  { id: 1, name: "Laptop", category: "Electronics", qty: 10, price: 65000, unit: "PCS", supplier: "TechCorp", location: "A1", sku: "LPT-001", status: "Available" },
  { id: 2, name: "Mouse", category: "Accessories", qty: 50, price: 500, unit: "PCS", supplier: "PeriTech", location: "A2", sku: "MSE-002", status: "Available" },
  { id: 3, name: "Keyboard", category: "Accessories", qty: 40, price: 1200, unit: "PCS", supplier: "PeriTech", location: "A2", sku: "KBD-003", status: "Available" },
  { id: 4, name: "Chair", category: "Furniture", qty: 15, price: 3500, unit: "PCS", supplier: "FurniCo", location: "B1", sku: "CHR-004", status: "Low Stock" },
  { id: 5, name: "Desk", category: "Furniture", qty: 8, price: 8500, unit: "PCS", supplier: "FurniCo", location: "B1", sku: "DSK-005", status: "Available" },

  { id: 6, name: "Pen", category: "Stationery", qty: 200, price: 10, unit: "PCS", supplier: "OfficeSup", location: "C1", sku: "PEN-006", status: "Available" },
  { id: 7, name: "Notebook", category: "Stationery", qty: 120, price: 50, unit: "PCS", supplier: "OfficeSup", location: "C1", sku: "NTB-007", status: "Available" },
  { id: 8, name: "Printer", category: "Electronics", qty: 3, price: 18000, unit: "PCS", supplier: "PrintCo", location: "A3", sku: "PRT-008", status: "Out of Stock" },
  { id: 9, name: "Ink Cartridge", category: "Supplies", qty: 25, price: 900, unit: "PCS", supplier: "PrintCo", location: "A3", sku: "INK-009", status: "Low Stock" },
  { id: 10, name: "USB Cable", category: "Accessories", qty: 60, price: 150, unit: "PCS", supplier: "CableTech", location: "A2", sku: "USB-010", status: "Available" },

]

export default function EditableGrid() {
  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        disableRowSelectionOnClick
      />
    </div>
  );
}
